import React, { useEffect, useRef } from 'react';
import './TestimonialCard.css'; // You'll need to combine CSS for both Carousel and Card in this file

const testimonials = [
    {
        testimonial: "🔥 Boost Interview's platform has been a revelation for my consulting interview prep. Their AI-driven feedback on case studies and situational questions is unparalleled. A true ally in navigating the consulting world! 🌈",
        name: 'Aiden',
        position: 'Consultant'
    },
    {
        testimonial: "🚀 Elevating my PM interview skills with Boost Interview was the best decision I made! The platform's insights on tackling product design questions are top-notch. Love how it prepares you for the real deal! 💡",
        name: 'Mia',
        position: 'Product Manager'
    },
    {
        testimonial: "Totally blown away by Boost Interview's AI guidance 🚀! Those real questions from top companies? Game changer for sure. Felt like I had insider info during my prep!",
        name: 'Alex',
        position: 'Data Analyst'
    },
    {
        testimonial: "Landing my dream job in tech felt so real after using Boost Interview. Those AI-driven mock interviews? Like the real deal! 🎉 Can't thank you enough!",
        name: 'Chris',
        position: 'Software Engineer'
    },
    {
        testimonial: "Just gotta say, Boost Interview made me feel so prepared and confident for my interviews. That AI evaluation is something else – spot on and super helpful! 👌",
        name: 'Jordan',
        position: 'UX Designer'
    },
    {
        testimonial: "Edge? Got it thanks to Boost Interview. The feedback on my practice was just what I needed. For anyone serious about acing that interview, this is where it's at. 💪 #HighlyRecommend",
        name: 'Samantha',
        position: 'Marketing Manager'
    },
    {
        testimonial: "Having Boost Interview's AI feedback was like a personal coach cheering me on. Every piece of advice was gold. 🌟 Changed the game for me.",
        name: 'Danielle',
        position: 'Project Manager'
    },
    {
        testimonial: "Mastering interviews? Done ✅, all thanks to Boost Interview's AI. If you wanna stand out, this platform is your secret weapon. Don't miss out!",
        name: 'Luis',
        position: 'Product Manager'
    },
    {
        testimonial: "💖 As an HR professional, Boost Interview has been invaluable in helping me prepare for strategic HR roles. The platform's scenario-based questions and feedback really make you think critically. A must-have for HR pros! 🌟",
        name: 'Oliver',
        position: 'Human Resources'
    }
];


const TestimonialCard = () => {
    const testimonialsRef = useRef(null);

    useEffect(() => {
        // Function to start animation
        const startAnimation = () => {
            // Ensure testimonialsRef.current is not null
            if (testimonialsRef.current) {
                // Get the width of a single testimonial card
                const cardWidth = testimonialsRef.current.firstChild.offsetWidth;
                // Calculate the total width of all original testimonials
                const totalWidthOfOriginals = cardWidth * testimonials.length;

                const keyframes = [
                    { transform: 'translateX(0)' },
                    { transform: `translateX(-${totalWidthOfOriginals}px)` }
                ];

                const animation = testimonialsRef.current.animate(keyframes, {
                    duration: totalWidthOfOriginals / 0.05, // Adjust the duration based on the width
                    iterations: Infinity,
                    easing: 'linear',
                });

                // Return a cleanup function to cancel the animation
                return () => animation.cancel();
            }
        };

        // Wait for the next browser repaint to ensure measurements are accurate
        requestAnimationFrame(startAnimation);

        // Cleanup function for useEffect
        // Note: This return statement should be directly inside useEffect, not in the requestAnimationFrame callback
        // Since there's no direct animation cancellation reference outside requestAnimationFrame, consider how to handle cleanup effectively
    }, []);


    return (
        <div className="testimonial-carousel-wrapper">
            <div className="testimonial-carousel" ref={testimonialsRef}>
                {testimonials.map((testimonial, index) => (
                    <div key={index} className="testimonial-card">
                        <div>
                            <div>
                                <p className="testimonial-author">{`${testimonial.name} (${testimonial.position})`}</p>
                            </div>
                        </div>
                        <p className="testimonial-text">{testimonial.testimonial}</p>
                    </div>
                ))}
                {/* Duplicate testimonials for seamless looping */}
                {testimonials.map((testimonial, index) => (
                    <div key={`duplicate-${index}`} className="testimonial-card">
                        <div>
                            <div>
                                <p className="testimonial-author">{`${testimonial.name} (${testimonial.position})`}</p>
                            </div>
                        </div>
                        <p className="testimonial-text">{testimonial.testimonial}</p>
                    </div>
                ))}
            </div>
        </div>
    );

};

export default TestimonialCard;
